var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"inner clearfix"},[_c('div',{staticClass:"workleft fl"},[_c('chapterid',{on:{"chapterid":_vm.chapterid,"zjgid":_vm.zjgid,"zjsidCopy":_vm.zjsidCopy}})],1),_c('div',{staticClass:"fr box"},[_c('navList')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }